import { useCareTeamSelector } from './useCareTeamSelector';
import { useDeepEqualMemo } from '@xolv-mybrightlink/common';
import { useCallback } from 'react';
import { Message } from '../../type';

export const useUploadingMessages = (channelGuid: string): Message[] => {
  const messages = useCareTeamSelector(
    useCallback(
      (state) => {
        if (state === 'LOADING') {
          return [];
        }
        const fileUploads = state.fileUploads[channelGuid] ?? {};
        return Object.values(fileUploads)
          .map((upload) => upload.message)
          .sort(
            (m1, m2) => m2.createdDate.nanoseconds - m1.createdDate.nanoseconds,
          );
      },
      [channelGuid],
    ),
  );
  return useDeepEqualMemo(messages);
};

export const useUploadingMessage = (
  channelGuid: string,
  messageGuid: string,
): Message | null => {
  const messages = useCareTeamSelector(
    useCallback(
      (state) => {
        if (state === 'LOADING') {
          return null;
        }
        return state.fileUploads[channelGuid]?.[messageGuid]?.message ?? null;
      },
      [channelGuid, messageGuid],
    ),
  );
  return useDeepEqualMemo(messages);
};
